import readCookie from './readCookie';
import getResultList from './getResultList';
import createListView from './createListView';
import createMapView from './createMapView';
// import listViewFilters from './listViewFilters';

// import pop up window for return point type detail
import ReturnPointTypePopUp from './returnPointTypePopUp';

var locationSearch = (function () {

    var setUpLocationSearch = function () {
        
        // get geo data from query string
        var getParameterByName = (function(a) {
            if (a == "") return {};
            var b = {};
            for (var i = 0; i < a.length; ++i)
            {
                var p=a[i].split('=', 2);
                if (p.length == 1)
                    b[p[0]] = "";
                else
                    b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
            }
            return b;
        })(window.location.search.substr(1).split('&'));

        var selectedLat = 0;
        var selectedLng = 0;
        var allReturnPointData = [];

        // initialize filter check state when page go back
        initializeCheckbox();
        var locationDisplay = sessionStorage.getItem('location');
        // if url has query string, means user actually type location in search box
        if(window.location.href.indexOf("latitude") > -1){
            $('.c-return-point-result').addClass('c-return-point-result__has-results');
            $('.c-return-point-result-wrapper h1').text("Return points '" + getParameterByName['locationName'] + "'");
            selectedLat = getParameterByName['latitude'];
            selectedLng = getParameterByName['longitude'];
            $('.c-return-point-result-wrapper .c-return-point-result--inner-wrapper').prepend(`<h4 class="u-text-primary-blue u-text--center">Showing Return Points near <br><span class="u-text-primary-green">${locationDisplay}</span></h4>`);
            // allReturnPointData = globalReturnPointsData;
            getResultList(selectedLat, selectedLng);
            createListView(getResultList(selectedLat, selectedLng));
            createMapView(getResultList(selectedLat, selectedLng), selectedLat, selectedLng);
        }
        else if(window.location.href.indexOf("outOfState") > -1){
            $('.c-return-point-result-wrapper .c-return-point-result--inner-wrapper').prepend(`<h4 class="u-text-primary-blue u-text--center">Showing Return Points near <br><span class="u-text-primary-green">${locationDisplay}</span></h4>`);
            $('.c-return-point-result').removeClass('c-return-point-result__has-results');
            $('.c-return-point-result-wrapper h1').hide();
            $('.c-search-results-filters').hide();
            $('.c-return-point-result-wrapper .subtitle').text("Return and Earn is a NSW residents scheme, please check that you are searching for a suburb or postcode in NSW.");
            $('.c-return-point-result--return-points-card-carousel').show();
            $('.c-return-point-result--return-points-card-carousel').removeClass('c-has-curve');
        }
        // if user didnt type any location in search box, read cookie if there is.
        else
        {
            if(readCookie('latitude')){
                $('.c-return-point-result-wrapper .c-return-point-result--inner-wrapper').prepend(`<h4 class="u-text-primary-blue u-text--center">Showing Return Points near <br><span class="u-text-primary-green">${locationDisplay}</span></h4>`);
                selectedLat = readCookie('latitude');
                selectedLng = readCookie('longitude');
                $('.c-return-point-result-wrapper h1').text("Return points nearby");
                $('.c-return-point-result').addClass('c-return-point-result__has-results');
                // allReturnPointData = globalReturnPointsData;
                getResultList(selectedLat, selectedLng);
                createListView(getResultList(selectedLat, selectedLng));
                createMapView(getResultList(selectedLat, selectedLng), selectedLat, selectedLng);
            }else{
                $('.c-return-point-result').removeClass('c-return-point-result__has-results');
                $('.c-return-point-result-wrapper').hide();
                $('.c-return-point-result--return-points-card-carousel').removeClass('c-has-curve');
            }
        }
        // if user already have geo location in cookie, call watch position to update cookie
        if(readCookie('latitude')){
            navigator.geolocation.watchPosition(
                successHandlingUpdateCookie
            )
        }
        function successHandlingUpdateCookie(position){
            let now = new Date();
            let time = now.getTime();
            let expireTime = time + 1000*3600000;
            now.setTime(expireTime);
            let expires = '; expires=' + now.toUTCString();
            if(position){
                document.cookie = "latitude=" + position.coords.latitude + expires + '; path=/';
                document.cookie = "longitude=" + position.coords.longitude + expires + '; path=/';
                document.cookie = "locationName=" + 'nearby' + expires + '; path=/';
            }
        }
        // if user didnt type any location in search box and not allow geo location, hide result list
        if(window.location.href.indexOf("latitude") == -1 
            && window.location.href.indexOf("outOfState") == -1
            && !readCookie('latitude')){
            $('.c-return-point-result').removeClass('c-return-point-result__has-results');
            $('.c-return-point-result-wrapper').hide();
        }
        /**
         * @param returnPointsList 
         * This function is for creating view with filtered return points
         */

        // Filters 
        // Return point type bitwise number
        var ReturnPointType = {
            All: 0,
            RVM: 1,
            OTC: 2,
            AD: 4,
            DonationStation: 8,
            OpenNow: 16
        }
        // each filters
        var $filterCheckboxes = $('.c-return-point-result--list-view .c-search-results-filters__items input[type="checkbox"]');
        var filteredReturnPointList=[];

        /**
         * With every filter is selected, recreate View
         */ 
        $filterCheckboxes.on('change', function() {
            var sortedReturnPointList = getResultList(selectedLat, selectedLng);
            var selectedFiltersSum = 0;
            filteredReturnPointList=[];
            
            // All Options
            // if(parseInt(this.value) == 0){
            //     $(this).parent().siblings().find('input').prop('checked',false);
            //     selectedFiltersSum = 0;
            // }else{
            //     $(this).parents('ul').children().first().find('input').prop('checked',false);
            // }
            $filterCheckboxes.filter(':checked').each(function() {
                // get selected filter bitwise sum
                selectedFiltersSum += parseInt(this.value);
            });
            // Return point type filters
            // var returnPointFilter = (selectedFiltersSum & (ReturnPointType.RVM | ReturnPointType.OTC | ReturnPointType.AD | ReturnPointType.DonationStation));
            // if(returnPointFilter == 0){
            //     returnPointFilter = ReturnPointType.RVM | ReturnPointType.OTC | ReturnPointType.AD | ReturnPointType.DonationStation;
            // }
            var returnPointFilter = ReturnPointType.RVM | ReturnPointType.OTC | ReturnPointType.AD | ReturnPointType.DonationStation;
            // Sub filters - open now
            var subFilter = (selectedFiltersSum & ReturnPointType.OpenNow);
            
            for(var i =0; i< sortedReturnPointList.length; i++){
                if( (sortedReturnPointList[i].cp_bitwise_sum & returnPointFilter) > 0 
                && (subFilter == 0 || (sortedReturnPointList[i].cp_bitwise_sum & subFilter) == subFilter) ){
                    filteredReturnPointList.push(sortedReturnPointList[i]);
                }
            }
            createListView(filteredReturnPointList);
        });
        
        function initializeCheckbox(){
            $('.c-search-results-filters__items input[type="checkbox"]').each(function() {
                $(this).prop('checked',false);
            });
        }

        // listViewFilters.init();
        $('.c-return-point-result--toggle-button button').click(function(){
            // $('.c-return-point-result--toggle-button').addClass('loading');
            // $('.c-return-point-result--toggle-button button').attr("disabled", "disabled");

            $('.c-return-point-result--map-view').toggleClass('show');
            if($('.c-return-point-result--map-view').hasClass('show')){
                $('.c-return-point-result--bottom-toggle-button.c-return-point-result--toggle-button').addClass('c-slide-up');
                $('.c-return-point-result--bottom-toggle-button.c-return-point-result--toggle-button').removeClass('c-slide-down');
            }else{
                if($('.c-return-point-result--top-toggle-button').hasClass('c-current-hidden')){
                    $('.c-return-point-result--bottom-toggle-button.c-return-point-result--toggle-button').addClass('c-slide-up');
                    $('.c-return-point-result--bottom-toggle-button.c-return-point-result--toggle-button').removeClass('c-slide-down');
                }else{
                     $('.c-return-point-result--bottom-toggle-button.c-return-point-result--toggle-button').toggleClass('c-slide-up');
                }
            }
            $('.c-return-point-result--bottom-toggle-button.c-return-point-result--toggle-button button').toggleClass('c-button--close-map');
        });
        $( window ).scroll(e =>{
            if($('.c-return-point-type-section').length){
                if(($(window).scrollTop() > 
                    ($('.c-return-point-result--top-toggle-button').offset().top 
                    - $('.c-return-point-result--top-toggle-button').innerHeight()))
                ){
                    $('.c-return-point-result--top-toggle-button').addClass('c-current-hidden');
                    $('.c-return-point-result--bottom-toggle-button').addClass('c-slide-up');
                    
                }else{
                    $('.c-return-point-result--top-toggle-button').removeClass('c-current-hidden');
                    $('.c-return-point-result--bottom-toggle-button').removeClass('c-slide-up');
                    
                }
                if($(window).scrollTop() < 
                ($('.c-return-point-type-section:last-of-type').offset().top +
                $('.c-return-point-type-section:last-of-type').innerHeight() - 230)){
                    $('.c-return-point-result--bottom-toggle-button').removeClass('c-slide-down');
                }else{
                    $('.c-return-point-result--bottom-toggle-button').addClass('c-slide-down');
                }
            }
        });
    };
  
    var init = function () {
        setUpLocationSearch();
    };

    // Set up RP features popup.
    if (typeof globalReturnPointsFeatures !== 'undefined') {
        ReturnPointTypePopUp(globalReturnPointsFeatures);
    }

    return {
      init: init
    };
})();
  
export default locationSearch;


// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/locationSearch.js